export function getNextPaidSubscription(subscriptions) {
  const now = new Date();

  const futureSubscriptions = subscriptions.filter((s) => {
    return s.status.id === 2 && new Date(s.startDate) > now;
  });

  futureSubscriptions.sort(
    (a, b) => new Date(a.startDate) - new Date(b.startDate),
  );

  return futureSubscriptions[0];
}
